import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=1129b49b&scoped=true"
import script from "./goodsInfo.vue?vue&type=script&lang=js"
export * from "./goodsInfo.vue?vue&type=script&lang=js"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=1129b49b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1129b49b",
  null
  
)

export default component.exports